import { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Button } from 'UIPackage/MainModule/components/Button';
import { IKnmHistoryItemChanges } from 'KnmPackage/KnmHistoriesModule/interfaces/IKnmHistoryItemChanges';
import { KnmHistoryItem } from 'KnmPackage/KnmHistoriesModule/components/KnmHistoryItem';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';

import styles from './PublishRulesHistory.module.scss';

const PAGE_SIZE = 10;

interface IPublishRulesHistoryProps {
  historyChanges: IKnmHistoryItemChanges[];
}

export const PublishRulesHistory = ({ historyChanges }: IPublishRulesHistoryProps) => {
  const [itemsPage, setItemsPage] = useState<number>(0);

  const lastVisibleItemsNumber = (itemsPage + 1) * PAGE_SIZE;
  const isLoadMoreButtonVisible = historyChanges.length > lastVisibleItemsNumber;

  const handleLoadMoreButtonClick = useCallback(() => setItemsPage(prev => prev + 1), []);

  return (
    <FieldBlock label="История изменений">
      {historyChanges.length > 0 && (
        <div className={styles.Items}>
          {historyChanges.map((knmHistoryItem, index) => {
            if (index > lastVisibleItemsNumber - 1) {
              return null;
            }

            return <KnmHistoryItem key={uuidv4()} data={knmHistoryItem} />;
          })}
        </div>
      )}

      {isLoadMoreButtonVisible && (
        <Button type="button" text="Показать еще" color="load" onClick={handleLoadMoreButtonClick} />
      )}
    </FieldBlock>
  );
};
